import * as React from "react";
import { useId } from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgListBullet = (props) => {
	const __svgrId = useId();
	return /* @__PURE__ */ _jsx("svg", {
		xmlns: "http://www.w3.org/2000/svg",
		viewBox: "0 0 640 640",
		fill: "currentColor",
		...props,
		children: /* @__PURE__ */ _jsx("path", { d: "M104 112C90.7 112 80 122.7 80 136L80 184C80 197.3 90.7 208 104 208L152 208C165.3 208 176 197.3 176 184L176 136C176 122.7 165.3 112 152 112L104 112zM248 136C234.7 136 224 146.7 224 160C224 173.3 234.7 184 248 184L552 184C565.3 184 576 173.3 576 160C576 146.7 565.3 136 552 136L248 136zM248 296C234.7 296 224 306.7 224 320C224 333.3 234.7 344 248 344L552 344C565.3 344 576 333.3 576 320C576 306.7 565.3 296 552 296L248 296zM248 456C234.7 456 224 466.7 224 480C224 493.3 234.7 504 248 504L552 504C565.3 504 576 493.3 576 480C576 466.7 565.3 456 552 456L248 456zM80 296L80 344C80 357.3 90.7 368 104 368L152 368C165.3 368 176 357.3 176 344L176 296C176 282.7 165.3 272 152 272L104 272C90.7 272 80 282.7 80 296zM104 432C90.7 432 80 442.7 80 456L80 504C80 517.3 90.7 528 104 528L152 528C165.3 528 176 517.3 176 504L176 456C176 442.7 165.3 432 152 432L104 432z" })
	});
};
export default SvgListBullet;
